import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { ThemeProvider } from "@/contexts/ThemeContext";
import Navbar from "@/components/sparkseed/Navbar";
import Hero from "@/components/sparkseed/Hero";
import ProblemTabs from "@/components/sparkseed/ProblemTabs";
import WhoWeAre from "@/components/sparkseed/WhoWeAre";
import InvestmentThesis from "@/components/sparkseed/InvestmentThesis";
import VentureStudio from "@/components/sparkseed/VentureStudio";
import DealFlowFunnel from "@/components/sparkseed/DealFlowFunnel";
import Portfolio from "@/components/sparkseed/Portfolio";
import PanIndia from "@/components/sparkseed/PanIndia";
import MentorNetwork from "@/components/sparkseed/MentorNetwork";
import Team from "@/components/sparkseed/Team";
import WhyPartner from "@/components/sparkseed/WhyPartner";
import FinalCTA from "@/components/sparkseed/FinalCTA";
import Footer from "@/components/sparkseed/Footer";
import PitchForm from "@/components/sparkseed/PitchForm";
import InvestForm from "@/components/sparkseed/InvestForm";
import Admin from "@/components/sparkseed/Admin";
import LightSwitch from "@/components/sparkseed/LightSwitch";
import ScrollProgress from "@/components/sparkseed/ScrollProgress";
import GrowthStem from "@/components/sparkseed/GrowthStem";
import JourneyRail from "@/components/sparkseed/JourneyRail";
import NextChapter from "@/components/sparkseed/NextChapter";
import ReturnsLab from "@/components/sparkseed/ReturnsLab";

function Landing() {
  const [pitchOpen, setPitchOpen] = useState(false);
  const [investOpen, setInvestOpen] = useState(false);

  const openPitch = () => setPitchOpen(true);
  const openInvest = () => setInvestOpen(true);

  return (
    <div className="bg-[#F7F8EF]">
      <Navbar onOpenPitch={openPitch} />
      <Hero onOpenPitch={openPitch} onOpenInvest={openInvest} />
      <ProblemTabs />
      <WhoWeAre />
      <InvestmentThesis />
      <MentorNetwork />
      <PanIndia />
      <VentureStudio />
      <DealFlowFunnel />
      <Portfolio />
      <NextChapter onOpenInvest={openInvest} />
      <ReturnsLab onOpenInvest={openInvest} />
      <Team />
      <WhyPartner onOpenPitch={openPitch} onOpenInvest={openInvest} />
      <FinalCTA onOpenPitch={openPitch} onOpenInvest={openInvest} />
      <Footer />

      <PitchForm open={pitchOpen} onClose={() => setPitchOpen(false)} />
      <InvestForm open={investOpen} onClose={() => setInvestOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <ScrollProgress />
        <GrowthStem />
        <JourneyRail />
        <LightSwitch />
        <Toaster position="top-right" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
